'use client';

import React from 'react';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from '@repo/ui/navigation-menu';

import { toClassName } from 'helpers/format';

import { TNextClientComponent } from 'types/next';

import { styles } from '.';

type TProps = {
  routes: { id: string; label: string; url: string }[];
  //
  locale: string;
};

const NavigationMenuSection: TNextClientComponent<TProps> = (props) => {
  const { routes } = props;

  const pathname = usePathname();

  const routes_ = routes.filter(
    (route) =>
      // route.id !== 'news' &&
      route.id !== 'jobs' && route.id !== 'home' && route.id !== 'contact',
  );

  return (
    <div className={styles.container}>
      <NavigationMenu className={styles.primary}>
        <NavigationMenuList>
          {routes_.map((route) => (
            <NavigationMenuItem key={route.id}>
              {route.url.includes('https') || route.url.includes('www') ? (
                <a
                  href={route.url.replaceAll('*', '')}
                  target={route.url.includes('*') ? '_blank' : ''}
                  className={toClassName(
                    styles.link,
                    pathname.includes(route.url) && '!opacity-20',
                  )}
                >
                  {route.label}
                </a>
              ) : (
                <Link
                  href={route.url.replaceAll('*', '')}
                  target={route.url.includes('*') ? '_blank' : ''}
                  legacyBehavior
                  passHref
                  as={route.url.replaceAll('*', '')}
                >
                  <NavigationMenuLink
                    className={toClassName(
                      styles.link,
                      pathname.includes(route.url) && '!opacity-20',
                    )}
                  >
                    {route.label}
                  </NavigationMenuLink>
                </Link>
              )}
            </NavigationMenuItem>
          ))}
        </NavigationMenuList>
      </NavigationMenu>
    </div>
  );
};

export default NavigationMenuSection;
